import Dummy from "components/Dummy";
import P from "components/P";

import { requester } from "App";
import clsx from "classnames";
import StarRate from "components/star/StarRate";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import btnSound from "resources/music/button-pressed-38129.mp3";
import categorySound from "resources/music/물방울.mp3";
import { useTouchClick } from "shared/hooks/useTouchClick";
import style from "./HorizontalVendingProductLayout2.module.css";

import folderBg2 from "resources/img/puffu/folderBg2.svg";
import HorizontalVendingProductDetail from "../product/HorizontalVendingProductDetail";
import HorizontalVendingProductInfo from "../product/HorizontalVendingProductInfo";
import ProductRadar2 from "../../process/product/ProductRadar2";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";



function DemoHorizontalVendingProductLayout3(props) {
    const { id } = useParams();
    const { data, currentTab, setCurrentTab, count, view } = props;
    const [quantity, setQuantity] = useState(1);
    const [avg, setAvg] = useState();
    const [hashTags, setHashTags] = useState([]);
    const [oneLineReviews, setOneLineReviews] = useState([]);
    const [radarData, setRadarData] = useState();
    const dispatch = useDispatch();
    const audioRef = useRef();
    const audio1Ref = useRef();
    const cartProducts = useSelector((state) => state.cart.products);
    const cartProduct = cartProducts.find(product => data && product.id === data.id);
    const cartQuantity = cartProduct ? cartProduct.quantity : 0;
    const cartRemainProducts = useSelector(state => state.cart.remainProducts);
    const cartRemainProduct = cartRemainProducts ? cartRemainProducts.find(product => product.id === data.id) : null;
    const cartRemainQuantity = cartRemainProduct ? cartRemainProduct.quantity : 0;
    const [showStockExceededMessage, setShowStockExceededMessage] = useState(false);


    const showStockExceeded = () => {
        setShowStockExceededMessage(true);
        setTimeout(() => {
            setShowStockExceededMessage(false);
        }, 3000); // 3초 후에 메시지 숨김
    };

    useEffect(() => {
        if (data) {

            // hashTag와 oneLineReview를 나누어 배열로 변환
            const hashTagsArray = data.hashTag ? data.hashTag.split('#').filter(tag => tag.trim() !== "") : [];
            const oneLineReviewsArray = data.oneLineReview ? data.oneLineReview.split('@').filter(review => review.trim() !== "") : [];

            // 상태에 저장
            setHashTags(hashTagsArray);
            setOneLineReviews(oneLineReviewsArray);
            setRadarData([data.bodyPoint, data.freshingPoint, data.hittingPoint, data.sweetPoint, data.throatHitPoint]);
            let reviewData = {
                productId: data.productId
            }
            requester.getTotalReviewRating(reviewData, (result) => {

                setAvg(result.data);
            })

            setQuantity(1)
        }
    }, [data])

    const handleTabClick = (tab) => {
        audioRef.current.play();
        setCurrentTab(tab);
    };

    const addCartClick = (e) => {

        audio1Ref.current.play();
        let cartProduct = cartProducts.find(product => data && product.id === data.id);
        let cartQuantity = cartProduct ? cartProduct.quantity : 0;
        let cartRemainProduct = cartRemainProducts ? cartRemainProducts.find(product => product.id === data.id) : null;
        let cartRemainQuantity = cartRemainProduct ? cartRemainProduct.quantity : 0;

        const totalQuantity = cartQuantity + cartRemainQuantity + quantity;

        if (totalQuantity > data.quantity) {
            showStockExceeded();
            return;
        }
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        const cartData = {
            roomId: id,
            code: "addCart",
            id: data.productId,
            cartList: [{ ...data, quantity: quantity, originQuantity: data.quantity }],
            deviceCode: deviceCode
            // remainingQuantity: remainingQuantity,
        }
        if (data.quantity > 0) {
            dispatch(CartReducer.actions.addProductToCart({ ...data, quantity: quantity, originQuantity: data.quantity }));
            // requester.testOrder(cartData, (result) => {
            // });
        } else {
            toast.error("품절된 상품입니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }

    }
    const infoTouch = useTouchClick(() => handleTabClick('info'));
    const detailTouch = useTouchClick(() => handleTabClick('detail'));
    // const reviewTouch = useTouchClick(() => handleTabClick('review'));


    const increaseQuantity = () => {
        audioRef.current.play();
        // 장바구니에 이미 담긴 현재 상품의 수량을 가져옵니다.
        let cartProduct = cartProducts.find(product => data && product.id === data.id);
        let cartQuantity = cartProduct ? cartProduct.quantity : 0;
        let cartRemainProduct = cartRemainProducts ? cartRemainProducts.find(product => product.id === data.id) : null;
        let cartRemainQuantity = cartRemainProduct ? cartRemainProduct.quantity : 0;

        // 수량을 1 증가시켰을 때의 총 수량을 계산합니다.
        const newQuantity = quantity + 1;
        const totalQuantity = cartQuantity + cartRemainQuantity + newQuantity;

        if (totalQuantity > data.quantity) {
            showStockExceeded();
            return;
        }

        setQuantity(newQuantity);
    };


    const decreaseQuantity = () => {
        audioRef.current.play();
        if (quantity > 1) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
        } else {

        }
    };


    const { handleTouchStart: decreaseTouchStart, handleTouchEnd: decreaseTouchEnd } = useTouchClick(decreaseQuantity, 10);
    const { handleTouchStart: increaseTouchStart, handleTouchEnd: increaseTouchEnd } = useTouchClick(increaseQuantity, 10);
    const { handleTouchStart: addCartTouchStart, handleTouchEnd: addCartTouchEnd } = useTouchClick(addCartClick, 10);
    return (
        <div className={style.productContainer}>
            {/* <div style={{ position: "absolute", zIndex: -1, left: "-2.5%", top: 0, width: "107.5%" }}> */}
            <div style={{ position: "absolute", zIndex: -1, left: 0, top: 0, width: "100%" }}>
                <img src={folderBg2} style={{ width: "100%", height: "100%", transform: "translateY(10px)" }} />
            </div>

            <audio ref={audioRef} src={categorySound} preload="auto" />
            <audio ref={audio1Ref} src={btnSound} preload="auto" />
            {showStockExceededMessage && (
                <div className={style.stockExceededMessage2}>
                    <P size={20} color={"red"} weight={900}>준비한 상품보다 많이 담았어요</P>
                </div>
            )}
            <HorizontalFlex flexStart gap={40}>
                <FlexChild>

                    <div style={{ transform: "translateX(6px)" }}

                        onPointerDown={(e) => e.stopPropagation()}
                        onPointerMove={(e) => e.stopPropagation()}
                        onPointerUp={(e) => e.stopPropagation()}>
                        <VerticalFlex gap={40}>
                            <FlexChild>
                                <HorizontalFlex gap={10}>
                                    <FlexChild width={"170px"} height={"max-content"} justifyContent={"center"} overflow ={'hidden'}  >
                                        <img src={data && data.productImg} width={"auto"} height={"170px"} style={{ transform: "translateX(10px)" }} />

                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex flexStart>
                                            <FlexChild>
                                                <VerticalFlex flexStart>
                                                    <FlexChild>
                                                        <P font={"Pretendard"} weight={700} size={"23px"}>{data && data.productName}</P>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <HorizontalFlex>
                                                            <FlexChild>
                                                                <P font={"Pretendard"} weight={800} color={"var(--point-color)"} size={"23px"}>{data ? data.price.toLocaleString() : null}</P>
                                                            </FlexChild>
                                                        </HorizontalFlex>
                                                        <Dummy height={"5px"} />
                                                        <FlexChild>
                                                            <P font={"Pretendard"} weight={500} color={"#7B7B7B"} size={"1vw"}>보유재고 {cartRemainQuantity ? data?.quantity - cartRemainQuantity : data?.quantity}개 / 누적 판매 {data.salesVolume && data.salesVolume}</P>
                                                        </FlexChild>
                                                        <Dummy height={"10px"} />
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                            <FlexChild>
                                                {view === "exhibition" ?
                                                    <P font={"Pretendard"} weight={800} color={"var(--point-color)"} size={24}>기획전 상품</P>
                                                    :
                                                    <HorizontalFlex gap={10}>
                                                        <FlexChild justifyContent={"flex-end"} width={"max-content"}>
                                                            <div
                                                                className={clsx(
                                                                    style.button,
                                                                    style["button--decrease"],
                                                                    { [style.disabled]: quantity === 1 }
                                                                )}
                                                                onPointerDown={decreaseTouchStart}
                                                                onPointerUp={decreaseTouchEnd}
                                                            >
                                                                <P font={"Pretendard"} weight={700} size={24} color={quantity === 1 ? "var(--point-color)" : "white"}>
                                                                    -
                                                                </P>
                                                            </div>
                                                        </FlexChild>

                                                        <FlexChild justifyContent={"center"}>
                                                            <div style={{ border: "1.5px solid rgba(215, 215, 215, 1)", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "3px" }}>
                                                                <P font={"Pretendard"} weight={"bold"} size={25}>
                                                                    {quantity && quantity}
                                                                </P>
                                                            </div>
                                                        </FlexChild>

                                                        <FlexChild justifyContent={"flex-start"} width={"max-content"}>
                                                            <div
                                                                className={clsx(
                                                                    style.button,
                                                                    style["button--increase"],
                                                                    { [style.disabled]: cartQuantity + cartRemainQuantity + quantity >= data.quantity }
                                                                )}
                                                                onPointerDown={increaseTouchStart}
                                                                onPointerUp={increaseTouchEnd}
                                                            >
                                                                <P
                                                                    font={"Pretendard"}
                                                                    weight={700}
                                                                    size={24}
                                                                    color={cartQuantity + cartRemainQuantity + quantity >= data.quantity ? "var(--point-color)" : "white"}
                                                                >
                                                                    +
                                                                </P>
                                                            </div>
                                                        </FlexChild>
                                                        <FlexChild width={"50%"} justifyContent={"flex-end"}>
                                                            <div className={style.addCartButton}
                                                                onPointerDown={addCartTouchStart}
                                                                onPointerUp={addCartTouchEnd}>
                                                                <Center>
                                                                    <P weight={700} size={18} width={"100%"} color={"white"} padding={"5px 15px"} cursor={"pointer"} font={"Pretendard"}>담기</P>
                                                                </Center>
                                                            </div>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                }
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalVendingProductDetail data={data} currentTab={currentTab}
                                    setCurrentTab={setCurrentTab} />
                            </FlexChild>
                        </VerticalFlex>
                    </div>
                </FlexChild>
                <FlexChild width={"max-content"}>
                    {/* <div style={{ width: "2px", height: "780px", backgroundColor: "rgba(185, 185, 185, 1)" }} /> */}
                    <div style={{ width: "2px", height: "665px", backgroundColor: "#B9B9B9", transform: 'translateY(120px)' }} />

                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild>
                            <HorizontalVendingProductInfo data={data} currentTab={currentTab}
                                setCurrentTab={setCurrentTab} />
                        </FlexChild>
                        <FlexChild>
                            <Dummy height={"80px"} />
                            <HorizontalFlex>
                                <FlexChild width={265}>
                                    <div className={style.box}>
                                        <VerticalFlex>
                                            <FlexChild>
                                                <div className={style.oneLineReviewBox2}>
                                                    <VerticalFlex gap={10}>
                                                        <FlexChild>
                                                            <HorizontalFlex gap={25} flexStart>
                                                                <FlexChild>
                                                                    <VerticalFlex gap={1} alignItems={"flex-start"}>
                                                                    <FlexChild width={"max-content"} justifyContent={"flex-start"}>
                                                                        <P size={22} font={"Pretendard"} weight={800}>평균 별점</P>
                                                                    </FlexChild>
                                                                    <FlexChild width={"max-content"} justifyContent={"flex-start"}>
                                                                        <P lineHeight={"100%"} color={"var(--point-color)"} size={32} font={"Pretendard"} weight={800}>{avg && avg.totalRating}</P>
                                                                    </FlexChild>
                                                                    <FlexChild width={"max-content"} >
                                                                        <div className={style.scoreWrap}>
                                                                            <div style={{ width: "100%" }}>
                                                                                {
                                                                                    avg &&
                                                                                    <StarRate score={avg.totalRating} />
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </FlexChild>
                                                                    </VerticalFlex>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <VerticalFlex flexStart gap={10}>
                                                                        {
                                                                            hashTags.length > 0
                                                                                ?
                                                                                hashTags.slice(0, 3).map((row, index) => (
                                                                                    <FlexChild>
                                                                                        <div className={style.hasTagBox2}>
                                                                                            <P color={"var(--point-color)"} size={16} font={"Pretendard"} weight={800}>#{row}</P>
                                                                                        </div>
                                                                                    </FlexChild>
                                                                                ))
                                                                                :
                                                                                <>
                                                                                    <FlexChild alignItems="flex-start">
                                                                                        <P color={"white"} size={18} font={"Pretendard"} weight={800}># 가성비</P>
                                                                                    </FlexChild>
                                                                                    <FlexChild alignItems="flex-start">
                                                                                        <P color={"white"} size={18} font={"Pretendard"} weight={800}># 재구매 많은</P>
                                                                                    </FlexChild >
                                                                                </>
                                                                        }
                                                                    </VerticalFlex>
                                                                </FlexChild>
                                                            </HorizontalFlex>

                                                        </FlexChild>
                                                        <FlexChild>
                                                            <VerticalFlex gap={10}>

                                                                {
                                                                    oneLineReviews.length > 0

                                                                        ?
                                                                        oneLineReviews.slice(0, 3).map((row, index) => (
                                                                            <FlexChild>
                                                                                <div className={style.reviewBox2}>
                                                                                    <P color={"black"} size={16} font={"Pretendard"} weight={500}>{`"`}{row}{`"`}</P>
                                                                                </div>
                                                                            </FlexChild>
                                                                        ))
                                                                        :
                                                                        <>
                                                                            <FlexChild>
                                                                                <div className={style.reviewBox}>
                                                                                    <P color={"black"} size={16} font={"Pretendard"} weight={800}>" 압도적인 쿨링과 밸런스 좋은 맛표현 "</P>
                                                                                </div>
                                                                            </FlexChild>
                                                                            <FlexChild>
                                                                                <div className={style.reviewBox}>
                                                                                    <P color={"black"} size={16} font={"Pretendard"} weight={800}>" 3통째 비우는 액상 "</P>
                                                                                </div>
                                                                            </FlexChild>
                                                                            <FlexChild>
                                                                                <div className={style.reviewBox}>
                                                                                    <P color={"black"} size={16} font={"Pretendard"} weight={800}>" 쿨찐들에겐 힘든 압도적 쿨링 "</P>
                                                                                </div>
                                                                            </FlexChild>
                                                                        </>
                                                                }

                                                            </VerticalFlex>
                                                        </FlexChild>

                                                    </VerticalFlex>
                                                </div>

                                            </FlexChild>

                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                                <FlexChild >
                                    <FlexChild width={"100%"}>
                                        <div style={{ width: "100%", transform: "translateY(20px)"}}>
                                            <ProductRadar2 data={radarData && radarData} />
                                        </div>
                                    </FlexChild>

                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </HorizontalFlex >
        </div >
    );
}

export default DemoHorizontalVendingProductLayout3;